/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GroupingWidgetConfiguration extends models.WidgetConfiguration {
    constructor() {
        super();
        this.setDiscriminator("GroupingWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return GroupingWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<GroupingWidgetConfiguration>): GroupingWidgetConfiguration {
        let obj = Object.assign(new GroupingWidgetConfiguration(), model);
        GroupingWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GroupingWidgetConfiguration>): GroupingWidgetConfiguration {
        if (!model) return null;
        return GroupingWidgetConfiguration.newInstance(<GroupingWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GroupingWidgetConfiguration) {
        if (!obj) return;

        models.GroupingWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GroupingWidgetConfiguration): boolean {
        if (models.WidgetConfiguration.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GroupingWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.numCols === undefined) {
            this.numCols = 0;
        }
        if (this.numRows === undefined) {
            this.numRows = 0;
        }
        if (this.widgets) {
            for (let val of this.widgets) {
                models.WidgetComposition.fixupPrototype(val);
            }
        }
    }

    numCols: number;

    numRows: number;

    widgets: Array<models.WidgetComposition>;

}
